import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { Product, Track } from "client-v2";
import ReactPixel from "react-facebook-pixel";

import Info from "./steps/Info";
import Header from "./steps/Header";
import Container from "../../components/container/Container";
import Resume from "./steps/Resume";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import styled from "styled-components";
import media from "styled-media-query";
import CurrencySelector from "../../components/selector/CurrencySelector";

const Background = styled.div<{ $backgroundImage: string }>`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	background-position-y: center;
	background-image: url(${(props) => props.$backgroundImage});
	${media.lessThan("medium")`
        display: none;
    `}
`;

const DonationWizard = (props: Props) => {
	const view = "donation";
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { setShowSuccess } = bindActionCreators(actionsCreators, dispatch);
	const appLocation = useSelector((state: State) => state.location.location);
	const currentUser = useSelector((state: State) => state.user.currentUser);
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const [selectedPrice, setSelectedPrice] = useState(15);
	const [selectedCharge, setSelectedCharge] = useState("monthly");
	const [loading, setLoading] = useState(false);
	const [utmData, setUtmData] = useState<{
		source?: string;
	}>({});

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const utmSource = params.get("utm_source");
		setUtmData({
			source: utmSource ? utmSource : undefined,
		});

		//Track to Mixpanel
		Track.event({
			event: "donation detail view init",
			user: currentUser,
			params: {
				view: "donation",
			},
		});
	}, []);

	const onShareClick = (op: any) => {
		const url = "https://adoptaunabuelo.org/donacion/";
		if (op.id === "twitter") {
			window.open("http://www.twitter.com/share?url=" + url, "_blank");
		} else if (op.id === "facebook") {
			window.open("http://www.facebook.com/sharer.php?u=" + url);
		} else if (op.id === "whatsapp") {
			window.open("whatsapp://send?text=" + url);
		} else if (op.id === "url") {
			navigator.clipboard.writeText(url);
			setShowSuccess({
				show: true,
				message: "Se ha copiado el enlace en tu portapapeles",
			});
		}
	};

	const onNextClick = () => {
		setLoading(true);
		Track.event({
			event: "donation progress init",
			user: currentUser,
			params: {
				view: view,
			},
		});
		Product.get({
			type: "subscription",
			price: selectedPrice,
			charge: selectedCharge,
			currency: appLocation ? appLocation.currency.name : "eur",
		})
			.then((result) => {
				const product = result.data[0];

				//Track on Mixpanel
				Track.event({
					event: "donation product selected",
					user: currentUser,
					params: {
						Product: product.objectId,
						amount: selectedPrice,
						view: view,
					},
				});

				//Track on Facebook
				ReactPixel.trackCustom("InitiateCheckout", {
					value: product.price,
					currency: appLocation ? appLocation.currency.name : "eur",
					product_id: product.objectId,
					product_name: product.title,
					customer_type: product.charge,
				});

				setLoading(false);
				navigate("/donacion/registro", {
					state: product,
				});
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	return (
		<>
			<Background
				$backgroundImage={require("../../assets/images/background/donation.webp")}
			/>
			<Container
				style={{ backgroundColor: "white" }}
				contentStyle={isMobile ? { paddingTop: 0 } : {}}
				headerProps={{
					logoBackgroundColor: "transparent",
					logoColor: isMobile ? "black" : "white",
					childrenPosition: "right",
					children: <CurrencySelector />,
				}}
				footerProps={{
					style: { backgroundColor: "transparent" },
					buttonProps: {
						style: {
							width: "100%",
						},
						children: `Quiero donar ${selectedPrice} ${
							appLocation ? appLocation.currency.symbol : "€"
						}${
							selectedCharge === "monthly"
								? " al mes"
								: selectedCharge === "annually"
								? " al año"
								: ""
						}`,
						loading: loading,
						onClick: onNextClick,
					},
				}}
				RightView={
					<Resume
						loading={loading}
						onPriceChange={(price, charge) => {
							setSelectedPrice(price);
							setSelectedCharge(charge);
						}}
						onClick={onNextClick}
						onShareClick={onShareClick}
					/>
				}
			>
				<Header utmSource={utmData.source}>
					<Resume
						style={{
							width: "unset",
						}}
						loading={loading}
						onPriceChange={(price, charge) => {
							setSelectedPrice(price);
							setSelectedCharge(charge);
						}}
						onClick={onNextClick}
						onShareClick={onShareClick}
					/>
				</Header>
				<Info price={selectedPrice} />
			</Container>
		</>
	);
};

export default DonationWizard;
export interface Props {}
